module.exports = __webpack_public_path__ + "img/icon_depth.a69a30dc.svg";